import React from "react";
import dynamic from "next/dynamic";
import LocationCard from "components/Locations/Location.card";
import { LocationFieldsType } from "types/business.types";
import { PaginateGenericType } from "types/generic.types";

const Map = dynamic(() => import("components/Locations/Map"), {
	ssr: false,
});

type Props = { locations: PaginateGenericType<LocationFieldsType> };

export default function Locations({ locations }: Props) {
	return (
		<>
			<Map locations={locations.items} />

			<div className="space-y-3 mt-4">
				{locations.items.map((location) => (
					<LocationCard
						id={location.id}
						key={location.id}
						title={location.name}
						address={location.address.displayAddress}
						phoneNumber={location?.phone?.number}
						countryCode={location?.phone?.countryCode}
						formattedNumber={location?.phone?.formattedNumber}
					/>
				))}
			</div>
		</>
	);
}
